import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteTable = function SvgRteTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5F62",
    fillRule: "evenodd",
    d: "M7 12v5h4v-5H7zm0-2h4V7H7v3zm6 2v5h4v-5h-4zm4-2h-4V7h4v3zm.5-5h-11A1.5 1.5 0 005 6.5v11A1.5 1.5 0 006.5 19h11a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0017.5 5z",
    clipRule: "evenodd"
  })));
};
var rteTable = SvgRteTable;

export { rteTable as default };
